import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasLoaded)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`api-sport api-sport-${_ctx.siteName}`)
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.comp), {
          matchId: _ctx.matchId,
          apiLiveUrl: _ctx.apiLiveUrl,
          isFetchOdd: _ctx.isFetchOdd
        }, null, 8, ["matchId", "apiLiveUrl", "isFetchOdd"]))
      ], 2))
    : _createCommentVNode("", true)
}